export enum VisualizationSourceType {
  Gltf = 'gltf',
  Url = 'url'
}